{
  "header": {
    "title": "Calendrier des questions",
    "description": "Consultez et analysez les réponses précédentes aux retours"
  },
  "categorySection": {
    "title": "Répartition par catégorie"
  }
}
